import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { Container, Logo, PreHeader } from '@scentregroup/ui'
import CentreFooter from '../../components/centre-footer'
import Header from '../../components/header'
import containerStyle from '../../components/container.scss'
import withCentre from '../../containers/with-centre'
import { centreType } from '../../types'
import getImageFromEntry, { MASTER } from '../../helpers/get-image-from-entry'
import WhatsHappeningListItem from '../../components/whats-happening-list-item'
import withWifiLanding from '../../containers/with-wifi-landing'
import { TimeZoneContext, PromotionPositionContext } from '../../context'
import pagesHoc from '../pages-hoc'
import Sponsor from './sponsor'
import style from './index.scss'

const FreeWifi = ({ template, centre, loading, offer, store, items }) => {
  if (loading) {
    return null
  }
  const brand = centre.country === 'Australia' ? 'optus' : 'vodafone'

  const image = getImageFromEntry(offer, MASTER)

  // Construct url/link and location to offer.
  const category = offer.__typename.toLowerCase()
  let offerLink = null
  let location = null

  if (store) {
    offerLink = `/${centre.slug}/${category}/${offer.sys.id}/${offer.slug}`
    location = `${store.title}${
      store.landmarkDescription ? `, ${store.landmarkDescription}` : ''
    }`
  }

  return (
    <TimeZoneContext.Provider value={centre.timeZone}>
      <PromotionPositionContext.Provider
        value={template?.analyticsMetadata?.displayId}
      >
        <Helmet>
          <title>{'Free Wifi'}</title>
        </Helmet>
        <div className={style.preheader} role="banner">
          <div className={style[`outer-${brand}`]}>
            <Container type="large" className={containerStyle.container}>
              <div className={style.inner}>
                <Sponsor
                  link={offerLink}
                  image={image}
                  heading={offer.title}
                  location={location}
                  body={offer.shortDescription}
                  brand={brand}
                  analyticsMetadata={offer.analyticsMetadata}
                />
              </div>
            </Container>
          </div>
          <PreHeader className={style[`brandColour-${brand}`]}>
            <Link to="/" title="Home" className={style.logo}>
              <Logo />
            </Link>
          </PreHeader>
        </div>

        <Header centre={centre} />

        <Container type="large" className={style.container}>
          {items.map(item => (
            <WhatsHappeningListItem {...item} key={item.link} />
          ))}
        </Container>

        <CentreFooter centre={centre} />
      </PromotionPositionContext.Provider>
    </TimeZoneContext.Provider>
  )
}

FreeWifi.propTypes = {
  loading: PropTypes.bool,
  centre: centreType,
  offer: PropTypes.object.isRequired,
  store: PropTypes.object,
  items: PropTypes.array,
  template: PropTypes.shape({
    analyticsMetadata: PropTypes.shape({
      displayId: PropTypes.string,
    }),
  }),
}

export default withCentre(withWifiLanding(pagesHoc(FreeWifi)))
